import React from 'react';
import { Link } from 'react-router-dom';
import {
    Button,
    Form,
    Row,
    Col,
    Select,
    DatePicker,
    AutoComplete,
} from 'antd';
const FormItem = Form.Item;
import { getProvinceAndAgent, actions, getProxyInfo, getProxyRepeatInfo, getAgentsProxyInfo } from './reducers';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
import Urls from '../../../../config';
const today = moment().format('YYYY-MM-DD');
const getDownloadUrl = Urls.PartnerUrl.downloadProxyData;
let searchData = {
    provinceId: '',
    cityId: '',
    agentName: '',
    day: moment().format('YYYY-MM-DD'),
};

const getParams = data => {
    let temp = [];
    for (let i in data) {
        if (data[i]) {
            temp.push(`${i}=${data[i]}`);
        }
    }
    return temp.join('&');
}

class Search extends React.Component {
    state = {
        agents: [],
    };
    constructor(props) {
        super(props);
        this.handleReset = this.handleReset.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
    }

    componentDidMount() {
        // this.getProvince();
        // this.getAgents();
        // this.props.getProxyInfo({ day: today }).then(() => {
        //     this.props.getProxyRepeatInfo({ day: today });
        // });
        this.props.getProvinceAndAgent();
    }
    handleReset() {
        this.props.form.resetFields();
        searchData = {
            provinceId: '',
            cityId: '',
            agentName: '',
            day: moment().format('YYYY-MM-DD'),
        };
    }

    // 查询
    handleSearch = e => {
        let values = this.props.form.getFieldsValue();
        console.log(values)

        if (typeof values.day !== 'undefined' && values.day) {
            let str = JSON.stringify(values, moment.format);
            let dateObj = JSON.parse(str);
            let day = dateObj.day.slice(0, 10);
            values.day = day;
        } else {
            values.day = today;
        }
        console.log('=====searchValue', values)
        this.props.changeSearchValues(values);
        this.props.getAgentsProxyInfo()
            .then(() => {
                this.props.getProxyInfo();
            })
            .then(() => {
                this.props.getProxyRepeatInfo();
            });
        e.preventDefault();
        return false;
    };
    caculateUrl = type => {
        searchData['type'] = type;
        let params = getParams(searchData);
        let downloadUrl = `${getDownloadUrl}?${params}`;
        return downloadUrl;
    };
    render() {
        // console.log('render');
        const { getFieldDecorator } = this.props.form;
        let { provinces, citys, agents, type} = this.props;

        return (
            <div>
                <h2 style={{ marginBottom: '20px' }}>代理商分析</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row style={{ marginBottom: '10px' }}>
                        <Col span={6}>
                            <FormItem label="省" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('provinceId')(
                                    /*<Select allowClear placeholder="全部" style={{ width: 160 }}>
                                        {provinces.map((item, index) => {
                                            return (
                                                <Option key={index} value={item.id}>
                                                    {item.name}
                                                </Option>
                                            );
                                        })}
                                    </Select>,*/
                                    <AutoComplete
                                        allowClear
                                        placeholder="全部"
                                        style={{ width: 160 }}
                                        dataSource={provinces.map((item, index) => {
                                            return (
                                                <Option key={index} value={item.id}>
                                                    {item.name}
                                                </Option>
                                            );
                                        })}
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    />,
                                )}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem label="市" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('cityId')(
                                    /*<Select allowClear placeholder="全部" style={{ width: 160 }}>
                                        {citys.map((item, index) => {
                                            return (
                                                <Option key={index} value={item.id}>
                                                    {item.name}
                                                </Option>
                                            );
                                        })}
                                    </Select>,*/
                                    <AutoComplete
                                        allowClear
                                        placeholder="全部"
                                        style={{ width: 160 }}
                                        dataSource={citys.map((item, index) => {
                                            return (
                                                <Option key={index} value={item.id}>
                                                    {item.name}
                                                </Option>
                                            );
                                        })}
                                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                                    />,
                                )}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem label="代理商" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('agentName')(
                                    <Select showSearch={true} allowClear placeholder="全部" style={{ width: 200 }}>
                                        {agents.map((item, index) => {
                                            return (
                                                <Option key={index} value={item.name}>
                                                    {item.name}
                                                </Option>
                                            );
                                        })}
                                    </Select>,
                                )}
                            </FormItem>
                        </Col>
                        <Col span={6}>
                            <FormItem label="时间" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
                                {getFieldDecorator('day', {
                                    initialValue: '',
                                })(
                                    <DatePicker
                                        style={{ width: 200 }}
                                        format="YYYY-MM-DD"
                                    />,
                                )}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row>
                        <Col span={24} style={{ textAlign: 'center', marginTop: '10px', marginBottom: '20px' }}>
                            <Button style={{ margin: '0 8px' }} onClick={this.handleReset}>
                                重置
                            </Button>
                            <Button type="primary" onClick={this.handleSearch} style={{ margin: '0 8px' }}>
                                搜索
                            </Button>
                            <Button><a href={this.caculateUrl(type)} download="filename">导出数据</a></Button>
                        </Col>
                    </Row>
                </Form>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    provinces: state.agencyAnalysis.provinces,
    citys: state.agencyAnalysis.citys,
    agents: state.agencyAnalysis.agents,
    type : state.agencyAnalysis.type,
});

const mapDispatchToProps = dispatch => ({
    getProvinceAndAgent: () => dispatch(getProvinceAndAgent()),
    getAgents: () => dispatch(getAgents()),
    changeSearchValues: values => dispatch(actions.changeSearchValues(values)),
    getProxyInfo: () => dispatch(getProxyInfo()),
    getProxyRepeatInfo: () => dispatch(getProxyRepeatInfo()),
    getAgentsProxyInfo: () => dispatch(getAgentsProxyInfo()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({
    onValuesChange(props, changedValues) {
        for (let i in changedValues) {
            if (i === 'day') {
                searchData[i] = moment(changedValues.day).format('YYYY-MM-DD');
            } else {
                searchData[i] = changedValues[i];
            }
        }
    },
})(Search));



// WEBPACK FOOTER //
// ./pages/StatisticalAnalysis/agencyAnalysis/search.js